import VContextMenu from './VContextMenu'

export { VContextMenu }
export default VContextMenu
